import type { FC } from 'react';
import { createContext, useContext } from 'react';

import type { NotifyMePopupConfig } from '../models';

type ContextValues = Omit<NotifyMePopupConfig, 'translations'>;

const AppContext = createContext<ContextValues>({
    currentLanguage: '',
    globalApiUrl: '',
    tenant: '',
    notifyMeSubscriptionConfiguration: {
        IsCumulusMarket: false,
        IsEditionEnabled: false,
        IsSmsSubscriptionEnabled: false,
        MarketingApprovalWarningText: '',
        NonCumulusIframeSrc: '',
        ShowMarketingApprovalWarning: false,
    },
});

export const useAppContext = () => useContext(AppContext);

export const AppContextProvider: FC<ContextValues> = ({ children, ...configs }) => (
    <AppContext.Provider value={configs}>{children}</AppContext.Provider>
);
